export default __webpack_public_path__ + "media/color/dgb-73035fbc.svg";